import { SET_BALANCE } from '../types'

const state = {
  data: {
    score: 0,
    visaFee: 0,
    usVisaFee: 0,
    insuranceBalance: 0,
    mallBalance: 0
  }
}

const mutations = {
  [SET_BALANCE](state, data) {
    state.data = data
  }
}

export default { state, mutations }